document.addEventListener("click", function (e) {
  const btn = e.target.closest(
    ".quick-add-button[data-product-id], .size-option[data-product-id], .variant-swatch[data-product-id]"
  );
  if (btn) {
    const productId = btn.getAttribute("data-product-id");
    const modal = document.querySelector(
      '.quick-add-modal[data-product-id="' + productId + '"]'
    );
    if (modal) {
      modal.style.display = "flex";
      // If size-option, pre-select the size in the modal
      if (btn.classList.contains("size-option")) {
        const sizeValue = btn.getAttribute("data-size");
        const swatch = modal.querySelector(
          '.variant-swatches .variant-swatch[data-value="' + sizeValue + '"]'
        );
        if (swatch) {
          swatch.parentElement
            .querySelectorAll(".variant-swatch")
            .forEach(function (s) {
              s.classList.remove("selected");
            });
          swatch.classList.add("selected");
          swatch.click();
        } else {
          // Find the product-option for Size
          const sizeOptionDiv = Array.from(
            modal.querySelectorAll(".product-option")
          ).find((optionDiv) => {
            const label = optionDiv.querySelector("label");
            return label && label.textContent.toLowerCase().includes("size");
          });
          if (sizeOptionDiv) {
            const sizeSelect = sizeOptionDiv.querySelector(".variant-select");
            if (sizeSelect) {
              sizeSelect.value = sizeValue;
              sizeSelect.dispatchEvent(new Event("change", { bubbles: true }));
            }
          }
        }
      }
      // If color swatch, pre-select color in the modal
      if (btn.classList.contains("variant-swatch")) {
        const colorValue = btn.getAttribute("data-color");
        const swatch = modal.querySelector(
          '.variant-swatches .variant-swatch[data-value="' + colorValue + '"]'
        );
        if (swatch) {
          swatch.parentElement
            .querySelectorAll(".variant-swatch")
            .forEach(function (s) {
              s.classList.remove("selected");
            });
          swatch.classList.add("selected");
          swatch.click();
        } else {
          // Target the color select by option position (assuming Color is position 1)
          const colorSelect = modal.querySelector(
            '.variant-select[data-option-position="1"]'
          );
          if (colorSelect) {
            colorSelect.value = colorValue;
            colorSelect.dispatchEvent(new Event("change", { bubbles: true }));
          }
        }
      }
    }
  }
});
document.addEventListener("mousedown", function (e) {
  const modal = e.target.closest(".quick-add-modal");
  if (modal && !e.target.closest(".quick-add-modal__content")) {
    modal.style.display = "none";
  }
});
document.addEventListener("click", function (e) {
  if (e.target.classList.contains("quick-add-modal__close")) {
    const modal = e.target.closest(".quick-add-modal");
    if (modal) modal.style.display = "none";
  }
});

//Quick add to cart
document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll(".quick-add-to-cart[data-product-id]")
    .forEach(function (button) {
      button.addEventListener("click", function (e) {
        e.preventDefault();
        var productId = button.getAttribute("data-product-id");
        // Find the modal to get variant data (already rendered in your HTML)
        var modal = document.getElementById("quick-add-modal-" + productId);
        if (!modal) return;
        var variants = JSON.parse(modal.getAttribute("data-variants"));
        if (!variants || variants.length === 0) return;
        var variantId = variants[0].id; // Use the first variant (default)
        var formData = new FormData();
        formData.append("id", variantId);
        formData.append("quantity", 1);
        fetch("/cart/add.js", {
          method: "POST",
          body: formData,
        })
          .then((response) => response.json())
          .then((data) => {
            if (window.innerWidth >= 1024) {
              button.textContent = "Added!";
            } else {
              button.classList.add("added");
            }
            updateCartCount();
          })
          .catch((error) => {
            button.textContent = "Error";
          });
      });
    });
});

function updateCartCount() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      const countEl = document.getElementById("CartCount");
      if (countEl) {
        countEl.textContent = cart.item_count;
        countEl.style.display = cart.item_count > 0 ? "inline-block" : "none";
      }
    });
}

updateCartCount();
